// extracted by mini-css-extract-plugin
module.exports = {"truncate":"cardBlog_truncate__IUEUy","card_content":"cardBlog_card_content__mHwXO","card_title":"cardBlog_card_title__Q_0_1","card_description":"cardBlog_card_description__T0uQu"};